import React from "react";

const Help = () => {
  return (
    <>
        <div className="mx-4 mt-58">
            <p>Help Page</p>
        </div>
    </>
  );
};

export default Help;
